import * as React from 'react'
import {
  asDashboardLoadingState,
  DashboardError,
  DataMessageEventHandler,
  ErrorMessageEventHandler,
  Iframe,
  MessageStrategy
} from '@mulesoft/monitoring-center-components'
import { IframeLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Iframe/IframeLoadingState'
import { DashboardLoadingState } from '@mulesoft/monitoring-center-components/lib/components/Dashboard/DashboardLoadingState'
import './ApplicationNetwork.css'

// Need to do this since there are multiple profile types defined with different values for organizationId.
export type CustomProfile = {
  id: string,
  organizationId: string,
  access_token: string,
}
export type Props = {
  relativeUrl: string,
  profile: CustomProfile | null,
  onDashboardStateChange: (loading: DashboardLoadingState, uri: string, iframe?: HTMLIFrameElement) => void
  onDashboardStateError: (error: DashboardError) => void
}

export class ApplicationNetwork extends React.PureComponent<Props> {
  private readonly profileHandler: DataMessageEventHandler<CustomProfile | null>
  private readonly errorHandler: ErrorMessageEventHandler<DashboardError>

  constructor(props: Props) {
    super(props)
    this.errorHandler = new ErrorMessageEventHandler(this.props.onDashboardStateError)
    this.profileHandler = new DataMessageEventHandler('Profile', this.props.profile)
    this.onIframeStateChange = this.onIframeStateChange.bind(this)
  }

  private onIframeStateChange(state: IframeLoadingState, uri: string, iframe?: HTMLIFrameElement) {
    this.props.onDashboardStateChange(asDashboardLoadingState(state), uri, iframe)
  }

  render() {
    const staticEventHandlers = [this.errorHandler, this.profileHandler]
    const displayedStrategy: MessageStrategy = {type: 'message'}
    return (
      <div className="application-network-tab">
        <Iframe
          sameOrigin={true}
          id="network-visualizer-iframe"
          src={this.props.relativeUrl}
          eventHandlers={staticEventHandlers}
          onIframeStateChange={this.onIframeStateChange}
          displayedStrategy={displayedStrategy}
        />
      </div>
    )
  }
}
